import { CarModel, ClientModel, LeadModel } from "../../domain/entitys";
import { LeadPayloadModel } from "../../domain/entitys/lead-payload.model";
import { AccessDeniedError, UnexpectedError } from "../../domain/errors";
import { CreateLead } from "../../domain/usecases";
import { HttpClient, HttpStatusCode } from "../entitys/http-client";

export class RemoteCreateLead implements CreateLead {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<LeadModel>
  ) { }

  async create(
    client: ClientModel,
    car: CarModel,
    value?: string
  ): Promise<LeadModel> {
    const payLoad: LeadPayloadModel = {
      first_name: client.name,
      phone: client.phone,
      vehicle_brand: car.brand,
      vehicle_model: car.model,
      vehicle_year: car.year,
    };
    const httpResponse = await this.httpClient.request({
      url: `${this.url}`,
      method: "post",
      body: payLoad,
      headers: {
        "x-webhook-secret": "lead"
      }
    });
    const remoteLead = httpResponse.body || undefined;
    switch (httpResponse.statusCode) {
      case 200:
        if (remoteLead?.deal_id) {
          return remoteLead;
        }
        throw new UnexpectedError();
      case HttpStatusCode.forbidden:
        throw new AccessDeniedError();
      default:
        throw new UnexpectedError();
    }
  }
}
